import {skipToken} from '@reduxjs/toolkit/query'

import {useThrottle} from '../../../../../hooks/useThrottle'
import {getSingleBuildArg} from '../../../../../rest/builds'
import {getBuildLocator} from '../../../../../rest/locators'
import {restApi} from '../../../../../services/rest'
import type {BuildId} from '../../../../../types'

import {useBuildParametersSubscription} from './useBuildParametersSubscription'

const THROTTLER_TIMEOUT = 2000

export const useQueryBuildSubscriptionForParameters = (buildId: BuildId) => {
  const {refetch} = restApi.endpoints.getBuildNormalized.useQuerySubscription(
    buildId != null ? getSingleBuildArg(getBuildLocator(buildId)) : skipToken,
  )
  const throttledFetch = useThrottle(refetch, THROTTLER_TIMEOUT)

  useBuildParametersSubscription(buildId, throttledFetch)
}
